module.exports = __webpack_public_path__ + "img/zalo.ecb8f5f9.svg";